import * as React from 'react';
import { Dispatch } from 'redux';
import { EventViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventNormalizers from '../normalizers/eventNormalizers';

export class GetAllEventsRequest extends BaseApiGetRequest<
  EventViewModel,
  EntityNormalizers.NormalizedEntityArray<EventNormalizers.NormalizedEvents>
> {
  constructor(archived: boolean, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events?archived=${archived}`;
    this.normalizeMethod = EventNormalizers.normalizeEventsArray;
  }
}
